module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 offset-lg-2 col-lg-8"
  }, [(_vm.apiErrorI18nKey) ? _c('div', {
    staticClass: "alert alert-danger mt-3",
    attrs: {
      "role": "alert"
    }
  }, [_c('b', [_vm._v("更新完了メッセージ")])]) : _vm._e(), _vm._v(" "), _c('page-form', {
    attrs: {
      "orderer": _vm.orderer,
      "user": _vm.user
    },
    on: {
      "tryForm": _vm.tryForm
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-08030c86!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/subPages/MyPage/OrdererInfo.vue
// module id = 669
// module chunks = 0